"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanAllen = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
class VanAllen extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.VAN_ALLEN,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L22',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.text('MILESTONES: ').megacredits(0).megacredits(3).any.asterix();
                    b.br.br;
                }),
                description: 'You may claim milestones for free (you must still meet the requirements). When any milestone is claimed, gain 3 M€.',
            },
        });
    }
    play() {
        return undefined;
    }
    canAct() {
        return false;
    }
    action() {
        return undefined;
    }
    static onMilestoneClaimed(game) {
        const owner = game.getPlayers().find((player) => player.cardIsInEffect(CardName_1.CardName.VAN_ALLEN));
        if (owner === undefined)
            return;
        owner.addResource(Resources_1.Resources.MEGACREDITS, 3, { log: true });
        return undefined;
    }
}
exports.VanAllen = VanAllen;
//# sourceMappingURL=VanAllen.js.map